module.exports = __webpack_public_path__ + "img/wenskaarten-kerstkaarten-kerst-papette-quotes-4.b08b50db.jpg";